import { FC, ReactNode } from "react";
import { cx } from "@jugl-web/utils";

export interface LiveChatUIContentBodyProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIContentBody: FC<LiveChatUIContentBodyProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      "mx-auto flex w-full max-w-[800px] flex-1 flex-col px-3",
      className
    )}
  >
    {children}
  </div>
);
